import { Outlet } from "react-router-dom";
import ProviderSidebar from "./provider_sidebar";
import ProviderHeader from "../../provider-header/components/index";
import ProviderFooter from "../../provider-footer/components/index";

// import ProviderHeader from "../../../../Clients/components/client-header/components/index";
// import ProviderFooter from "../../../../Clients/components/client-footer/components/index";

const ProviderDashboard = () => {
  return (
    <>
    <ProviderHeader />
    {/* <div className="d-flex">
      <ProviderSidebar />
      <div className="flex-grow-1 p-4">
        <Outlet />
      </div>
    </div> */}
    <main className="overflow-hidden">
      <section className="homepad">
        <div className="container">
          <div className="row">
            <ProviderSidebar />
            <Outlet />
          </div>
        </div>
      </section>
      <ProviderFooter />
    </main>
    </>
  );
};

export default ProviderDashboard;